import { render } from "./not-me-link.vue?vue&type=template&id=720366c0"
import script from "./not-me-link.vue?vue&type=script&lang=js"
export * from "./not-me-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__